import {CarteraInterface} from "../models/cartera.interface";

export namespace WalletsAction {



  export class FetchWallets {

    static readonly type = '[WalletsAction] Fetch carteras';
    constructor(public hideLoading = false, public id = null) {}
  }

  export class UpsertWallet {

    static readonly type = '[Action] Add cartera';
    constructor(public cartera: CarteraInterface) {}
  }

  export class CloneWallet {

    static readonly type = '[WalletsAction] Clone cartera';
    constructor(public id: number) {}
  }

  export class RemoveWallet {

    static readonly type = '[WalletAction] Remove cartera';
    constructor(public id: number) {}
  }

}
